'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { HStack, VStack } from '@/components/Layout';
import { AddStepperCompleteDialog } from '@/components/Stepper';
import { ConfirmDeviceGroup } from '@/features/device-group/components/ConfirmDeviceGroup';
import { DEVICE_GROUP_WIZARD_HASH } from '@/features/device-group/constants';
import { useDeviceGroupWizardStore } from '@/features/device-group/hooks/useDeviceGroupWizardStore';
import { useDuplicateDeviceGroupName } from '@/features/device-group/hooks/useDuplicateDeviceGroupName';
import { buildPreviewBody, useCreateDeviceGroupMutation } from '@/features/device-group/query';
import Processing from '@/features/import-csv/-components/Processing';
import { defaultNS, useTranslation } from '@/lib/i18n';
import AddStepperNavigation from '../-components/AddStepperNavigation';
import AddStepperPanelProgress from '../-components/AddStepperPanelProgress';
import AddStepperStepTitleCard from '../-components/AddStepperStepTitleCard';
import BasicForm from '../-components/BasicForm';
import GenreRulesStep from '../-components/GenreRulesStep';
import useDeviceGroupWizardHash from '../-hooks/useHash';
export const Route = createFileRoute('/_staff/devices/_form/device-groups/new/')({
  component: RouteComponent
});
const BASE_LINK = '/devices/device-groups/new';
function RouteComponent() {
  const {
    hash
  } = useDeviceGroupWizardHash();
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.settings.deviceGroups.wizard'
  });
  const form = useDeviceGroupWizardStore(s => s.form);
  const reset = useDeviceGroupWizardStore(s => s.reset);
  const patchForm = useDeviceGroupWizardStore(s => s.patchForm);
  const patchGenreRule = useDeviceGroupWizardStore(s => s.patchGenreRule);
  useEffect(() => {
    reset();
    return () => reset();
  }, [reset]);
  const isDuplicateName = useDuplicateDeviceGroupName(form.name);
  const createMutation = useCreateDeviceGroupMutation();
  const [isComplete, setIsComplete] = useState(false);
  const isPending = createMutation.isPending;
  const handleCreate = () => {
    createMutation.mutate(buildPreviewBody(form), {
      onSuccess: () => setIsComplete(true)
    });
  };
  return <HStack className="h-[calc(100vh-64px)] w-full gap-9 p-10">
      <AddStepperNavigation baseLink={BASE_LINK} currentHash={hash} isEdit={false} />

      <VStack className="h-full min-w-0 w-full gap-6">
        {isPending && <Processing hash={hash} />}
        {!isPending && <>
            <AddStepperStepTitleCard hash={hash} />
            <div className="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto">
              {hash === DEVICE_GROUP_WIZARD_HASH.FORM && <BasicForm form={form} onChange={patchForm} isDuplicateName={isDuplicateName} />}

              {hash === DEVICE_GROUP_WIZARD_HASH.SET_GENRE_RULES && <GenreRulesStep form={form} onPatchForm={patchForm} onGenreRuleChange={patchGenreRule} />}

              {hash === DEVICE_GROUP_WIZARD_HASH.CONFIRM && <ConfirmDeviceGroup form={form} />}
            </div>

            <AddStepperPanelProgress baseLink={BASE_LINK} currentHash={hash} form={form} isDuplicateName={isDuplicateName} onSubmit={handleCreate} />
          </>}

        {isComplete && <AddStepperCompleteDialog completeMessage={t('completeDialog.createMessage')} completeLinkButtonText={t('completeDialog.listLink')} completeLinkUrl="/devices/settings/device-groups" />}
      </VStack>
    </HStack>;
}